module.exports = __webpack_public_path__ + "static/media/helloSplash315_12_8R.eb1109fb.png";